/* Broworkshop · página de inicio */
(function () {
  'use strict';

  const BW = window.BW;
  const { $, $$, esc, norm, money, imgUrl, srcset, icon, ui, catMeta, C } = BW;

  const CITIES = ['Bogotá', 'Medellín', 'Cali', 'Barranquilla', 'Cartagena', 'Bucaramanga', 'Pereira', 'Manizales',
    'Santa Marta', 'Cúcuta', 'Ibagué', 'Villavicencio', 'Pasto', 'Montería', 'Neiva', 'Armenia', 'Popayán',
    'Tunja', 'Valledupar', 'Riohacha', 'Leticia', 'Sincelejo', 'Quibdó', 'Yopal', 'Florencia'];

  $$('[data-contact-link]').forEach((a) => {
    if (!ui.hasWhatsApp()) { a.href = C.contactUrl; return; }
    a.href = ui.waLink('¡Hola Broworkshop! 👋 Tengo una pregunta.');
    a.classList.replace('btn--soft', 'btn--wa');
    a.innerHTML = `${icon('wa')}Escríbenos por WhatsApp`;
  });

  const citiesBox = $('[data-cities]');
  if (citiesBox) {
    citiesBox.innerHTML = ui.marquee(CITIES.map((c) => `<span class="city">${c}</span>`).join(''), { speed: 50 });
  }

  initFaq();
  initTabsUI();

  // SMIL (camión animado) no respeta la preferencia de movimiento reducido por sí solo.
  if (!BW.motionOK()) $$('.route > svg').forEach((svg) => svg.pauseAnimations && svg.pauseAnimations());

  BW.loadCatalog()
    .then(render)
    .catch((err) => {
      console.error('[inicio]', err);
      initHero();
      const panel = $('[data-tab-panel]');
      if (panel) {
        panel.innerHTML = ui.emptyState({
          title: 'No pudimos cargar los productos',
          text: 'Revisa tu conexión a internet e inténtalo de nuevo.',
          actions: '<button class="btn btn--primary" type="button" onclick="location.reload()">Reintentar</button>',
          art: 'alert',
        });
        ui.reveal(panel);
      }
    });

  function render(items) {
    const avail = items.filter((p) => p.available && p.image);
    fillHero(avail);
    initHero();
    renderCategories(items);
    renderTabs(avail);
    renderDeal(avail);
    renderStrip(avail);
    renderStats(items);
    renderBrands(items);
    renderCtaFloats(avail);
    ui.reveal();
  }

  /* ───────────── Banners ───────────── */
  function pick(source, items) {
    const [kind, arg = ''] = source.split(':');
    const distinctBy = (list, key) => {
      const seen = new Set();
      return list.filter((p) => !seen.has(key(p)) && seen.add(key(p)));
    };
    switch (kind) {
      case 'mix':
        return distinctBy(items, (p) => p.typeSlug).slice(0, 3);
      case 'sale':
        return items.filter((p) => p.discount > 0).sort((a, b) => b.discount - a.discount).slice(0, 3);
      case 'type':
        return items.filter((p) => p.typeSlug === arg).slice(0, 3);
      case 'brands': {
        const wanted = arg.split(',').map(norm);
        const list = items.filter((p) => wanted.includes(norm(p.vendor)));
        const first = distinctBy(list, (p) => p.vendor);
        return [...first, ...list.filter((p) => !first.includes(p))].slice(0, 3);
      }
      case 'q': {
        const found = new Map();
        arg.split('|').forEach((term) => {
          const tokens = BW.tokenize(term);
          items.forEach((p) => {
            const s = BW.searchScore(p, tokens);
            if (s > 0) found.set(p, Math.max(found.get(p) || 0, s));
          });
        });
        return [...found.entries()].sort((a, b) => b[1] - a[1] || a[0].rank - b[0].rank).map(([p]) => p).slice(0, 3);
      }
      default:
        return items.slice(0, 3);
    }
  }

  function stickerInner(label, list) {
    if (label === 'sale') {
      const max = Math.max(...list.map((p) => p.discount));
      return `<b><small>Hasta</small>-${max}%</b>`;
    }
    if (label === 'music') return icon('music');
    if (label === 'coffee') return icon('coffee');
    return '<i class="flag-dot"></i>';
  }

  function stageHTML(list, slide, index) {
    const [main, a, b] = list;
    const ring = slide.dataset.ring || '';
    return `
      <div class="stage">
        <span class="stage__ring" aria-hidden="true"></span>
        <a class="stage__main" href="${ui.productUrl(main.handle)}" aria-label="${esc(main.title)}">
          <img class="float" src="${imgUrl(main.image, 720)}" srcset="${srcset(main.image, [360, 540, 720, 960])}"
            sizes="(max-width: 860px) 64vw, 400px" alt="${esc(main.alt)}" ${index === 0 ? 'fetchpriority="high"' : 'loading="lazy"'}>
        </a>
        <a class="stage__price" href="${ui.productUrl(main.handle)}" tabindex="-1">
          <small>${main.compare ? `Antes ${money(main.compare)}` : esc(main.type)}</small>
          <b>${money(main.price)}</b>
        </a>
        ${a ? `<a class="stage__card stage__card--a" href="${ui.productUrl(a.handle)}" aria-label="${esc(a.title)}">
          <img class="float-slow" src="${imgUrl(a.image, 320)}" alt="" loading="lazy"><span>${money(a.price)}</span></a>` : ''}
        ${b ? `<a class="stage__card stage__card--b" href="${ui.productUrl(b.handle)}" aria-label="${esc(b.title)}">
          <img class="float-rev" src="${imgUrl(b.image, 320)}" alt="" loading="lazy"><span>${money(b.price)}</span></a>` : ''}
        <span class="stage__sticker" aria-hidden="true">
          <svg viewBox="0 0 120 120"><defs><path id="ring-${index}" d="M60,60 m-45,0 a45,45 0 1,1 90,0 a45,45 0 1,1 -90,0"/></defs>
            <text><textPath href="#ring-${index}">${esc(ring)}</textPath></text></svg>
          ${stickerInner(slide.dataset.label, list)}
        </span>
      </div>`;
  }

  function fillHero(items) {
    const saleCount = items.filter((p) => p.discount > 0).length;
    $$('[data-sale-count]').forEach((el) => {
      el.textContent = saleCount >= 20 ? `Más de ${Math.floor(saleCount / 10) * 10}` : String(saleCount);
    });
    $$('[data-slide]').forEach((slide, i) => {
      const list = pick(slide.dataset.source || 'mix', items);
      if (!list.length) {
        if (!slide.classList.contains('is-active')) slide.remove();
        return;
      }
      $('[data-visual]', slide).innerHTML = stageHTML(list, slide, i);
    });
  }

  function initHero() {
    const hero = $('[data-hero]');
    if (!hero || hero.dataset.ready) return;
    hero.dataset.ready = '1';
    const slides = $$('[data-slide]', hero);
    const dotsBox = $('[data-dots]', hero);
    const toggle = $('[data-hero-toggle]', hero);
    const DURATION = 6500;
    let index = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active')));
    let timer = 0;
    let hovering = false;
    let stopped = !BW.motionOK();

    hero.style.setProperty('--dur', `${DURATION}ms`);
    dotsBox.innerHTML = slides.map((_, i) =>
      `<button class="hero__dot" type="button" aria-label="Ver banner ${i + 1} de ${slides.length}"><span class="bar"><i></i></span></button>`).join('');
    const dots = $$('.hero__dot', dotsBox);

    function paint() {
      slides.forEach((s, i) => {
        const on = i === index;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-label', `${i + 1} de ${slides.length}`);
        s.setAttribute('aria-hidden', String(!on));
        s.inert = !on;
      });
      dots.forEach((d, i) => {
        d.classList.toggle('is-active', i === index);
        d.setAttribute('aria-current', i === index ? 'true' : 'false');
        const bar = $('i', d);
        bar.style.animation = 'none';
        void bar.offsetWidth;
        bar.style.animation = '';
      });
    }

    function schedule() {
      clearTimeout(timer);
      const paused = hovering || stopped || document.hidden;
      hero.classList.toggle('is-paused', paused);
      hero.classList.toggle('is-stopped', stopped);
      if (!paused) timer = setTimeout(() => go(index + 1), DURATION);
    }

    function go(n) {
      const next = (n + slides.length) % slides.length;
      if (next === index) return;
      const prev = slides[index];
      prev.classList.add('is-leaving');
      setTimeout(() => prev.classList.remove('is-leaving'), 900);
      index = next;
      paint();
      schedule();
    }

    dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
    $('[data-hero-prev]', hero).addEventListener('click', () => go(index - 1));
    $('[data-hero-next]', hero).addEventListener('click', () => go(index + 1));

    function setStopped(value) {
      stopped = value;
      toggle.setAttribute('aria-pressed', String(stopped));
      toggle.setAttribute('aria-label', stopped ? 'Reanudar banners' : 'Pausar banners');
      toggle.innerHTML = icon(stopped ? 'play' : 'pause');
      paint();
      schedule();
    }
    toggle.addEventListener('click', () => setStopped(!stopped));

    hero.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') { hovering = true; schedule(); } });
    hero.addEventListener('pointerleave', (e) => {
      if (e.pointerType !== 'mouse') return;
      hovering = false;
      $$('.stage', hero).forEach((s) => { s.style.removeProperty('--px'); s.style.removeProperty('--py'); });
      paint();
      schedule();
    });
    hero.addEventListener('focusin', () => { hovering = true; schedule(); });
    hero.addEventListener('focusout', (e) => { if (!hero.contains(e.relatedTarget)) { hovering = false; paint(); schedule(); } });
    document.addEventListener('visibilitychange', schedule);
    hero.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') go(index + 1);
      if (e.key === 'ArrowLeft') go(index - 1);
    });

    // Deslizar con el dedo
    let sx = 0;
    let sy = 0;
    hero.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    hero.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - sx;
      const dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) go(index + (dx < 0 ? 1 : -1));
    }, { passive: true });

    // Profundidad (parallax) con el mouse
    let frame = 0;
    hero.addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse' || !BW.motionOK() || frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        const stage = $('.slide.is-active .stage', hero);
        if (!stage) return;
        const r = hero.getBoundingClientRect();
        stage.style.setProperty('--px', ((e.clientX - r.left) / r.width - 0.5).toFixed(3));
        stage.style.setProperty('--py', ((e.clientY - r.top) / r.height - 0.5).toFixed(3));
      });
    });

    paint();
    if (stopped) setStopped(true);
    else schedule();
  }

  /* ───────────── Categorías ───────────── */
  function renderCategories(items) {
    const box = $('[data-cats]');
    if (!box) return;
    const cats = BW.categoriesOf(items);
    const shown = cats.slice(0, 8);
    const rest = cats.slice(8);
    const tile = (c, i) => {
      const big = i === 0;
      const imgs = c.items.filter((p) => p.image).slice(0, big ? 3 : 1);
      return `
        <a class="cat tone-${c.tone}${big ? ' cat--big' : ''}" href="${ui.shopUrl({ cat: c.slug })}" data-reveal style="--d:${i * 60}ms">
          <div class="cat__text">
            <span class="cat__icon">${icon(c.icon)}</span>
            <h3>${esc(c.name)}</h3>
            ${big ? `<p>${esc(c.blurb)}</p>` : ''}
            <span class="cat__count">${c.count} producto${c.count === 1 ? '' : 's'} ${icon('arrow')}</span>
          </div>
          <div class="cat__imgs" aria-hidden="true">
            ${imgs.map((p, k) => `<img class="cat__img cat__img--${k + 1}" src="${imgUrl(p.image, big ? 520 : 360)}" alt="" loading="lazy" decoding="async">`).join('')}
          </div>
        </a>`;
    };
    box.innerHTML = shown.map(tile).join('') + `
      <a class="cat cat--all" href="${BW.R.shop}" data-reveal style="--d:${shown.length * 60}ms">
        <div class="cat__text">
          <span class="cat__icon">${icon('grid')}</span>
          <h3>Ver todo el catálogo</h3>
          <span class="cat__count">${cats.length} categorías · ${items.length} productos ${icon('arrow')}</span>
        </div>
        ${rest.length ? `<div class="cat__chips">${rest.map((c) => `<span>${esc(c.name)}</span>`).join('')}</div>` : ''}
      </a>`;
  }

  /* ───────────── Pestañas de productos ───────────── */
  const TABS = {
    top: { list: (xs) => xs.slice(0, 8), more: BW.R.shop, label: 'Ver todos los productos' },
    sale: {
      list: (xs) => xs.filter((p) => p.discount > 0).sort((a, b) => b.discount - a.discount).slice(0, 8),
      more: ui.shopUrl({ oferta: 1, orden: 'descuento' }),
      label: 'Ver todas las ofertas',
    },
    best: { list: (xs) => xs.filter((p) => p.bestPrice).slice(0, 8), more: ui.shopUrl({ mejor: 1 }), label: 'Ver todo con mejor precio' },
    cocina: { list: (xs) => xs.filter((p) => p.typeSlug === 'cocina').slice(0, 8), more: ui.shopUrl({ cat: 'cocina' }), label: 'Ver toda la cocina' },
  };
  let tabItems = null;

  function moveInk(btn) {
    const tabs = $('[data-tabs]');
    const ink = $('.tabs__ink', tabs);
    if (!btn || !ink) return;
    ink.style.setProperty('--x', `${btn.offsetLeft}px`);
    ink.style.setProperty('--w', `${btn.offsetWidth}px`);
  }

  function initTabsUI() {
    const tabs = $('[data-tabs]');
    if (!tabs) return;
    const buttons = $$('[role="tab"]', tabs);
    const panel = $('[data-tab-panel]');
    panel.innerHTML = ui.skeletons(8);
    const select = (btn, focus = false) => {
      buttons.forEach((b) => {
        const on = b === btn;
        b.setAttribute('aria-selected', String(on));
        b.tabIndex = on ? 0 : -1;
      });
      if (focus) btn.focus();
      panel.setAttribute('aria-labelledby', btn.id);
      moveInk(btn);
      showTab(btn.dataset.tabKey);
    };
    buttons.forEach((b, i) => {
      b.addEventListener('click', () => select(b));
      b.addEventListener('keydown', (e) => {
        const dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        select(buttons[(i + dir + buttons.length) % buttons.length], true);
      });
    });
    const current = () => buttons.find((b) => b.getAttribute('aria-selected') === 'true');
    requestAnimationFrame(() => moveInk(current()));
    window.addEventListener('resize', BW.debounce(() => moveInk(current()), 100));
    if (document.fonts) document.fonts.ready.then(() => moveInk(current()));
  }

  function showTab(key) {
    const panel = $('[data-tab-panel]');
    const more = $('[data-tab-more]');
    const tab = TABS[key] || TABS.top;
    if (!tabItems) return;
    panel.classList.add('is-switching');
    setTimeout(() => {
      const list = tab.list(tabItems);
      panel.innerHTML = list.length
        ? list.map((p, i) => ui.card(p, i)).join('')
        : ui.emptyState({ title: 'Pronto tendremos productos aquí', art: 'box' });
      if (more) {
        more.href = tab.more;
        more.firstChild.textContent = `${tab.label} `;
      }
      panel.classList.remove('is-switching');
      ui.reveal(panel);
    }, panel.children.length && !panel.querySelector('.card--skeleton') ? 200 : 0);
  }

  function renderTabs(items) {
    tabItems = items;
    const selected = $('[data-tabs] [aria-selected="true"]');
    showTab(selected ? selected.dataset.tabKey : 'top');
  }

  /* ───────────── Oferta destacada ───────────── */
  function renderDeal(items) {
    const box = $('[data-deal]');
    if (!box) return;
    const deal = items
      .filter((p) => p.discount > 0 && p.variantId)
      .sort((a, b) => (b.compare - b.price) - (a.compare - a.price))[0];
    if (!deal) return;
    const url = ui.productUrl(deal.handle);
    box.innerHTML = `
      <div class="deal__copy">
        <span class="eyebrow eyebrow--glass"><i class="dot"></i>Oferta destacada</span>
        <p class="deal__cat">${esc(deal.type)}${deal.vendor ? ` · ${esc(deal.vendor)}` : ''}</p>
        <h2 class="deal__title">${esc(deal.title)}</h2>
        <div class="deal__prices"><b>${money(deal.price)}</b><s><span class="sr">Antes </span>${money(deal.compare)}</s></div>
        <p class="deal__save">${icon('sparkles')}Ahorras ${money(deal.compare - deal.price)}</p>
        <div class="deal__cta">
          <button class="btn btn--yellow btn--lg" type="button" data-add="${esc(deal.variantId)}" data-handle="${esc(deal.handle)}" data-magnetic>${icon('bag')}Agregar al carrito</button>
          <a class="btn btn--glass btn--lg" href="${url}">Ver detalles ${icon('arrow')}</a>
        </div>
      </div>
      <div class="deal__visual">
        <span class="deal__orbit o1" aria-hidden="true"></span>
        <span class="deal__orbit o2" aria-hidden="true"></span>
        <a class="deal__disc" href="${url}" aria-label="${esc(deal.title)}">
          <img class="float" src="${imgUrl(deal.image, 720)}" srcset="${srcset(deal.image, [360, 540, 720])}" sizes="(max-width: 860px) 70vw, 380px" alt="${esc(deal.alt)}" loading="lazy">
        </a>
        <span class="deal__burst" aria-hidden="true"><small>Ahorra</small><b>-${deal.discount}%</b></span>
      </div>`;
    box.hidden = false;
  }

  /* ───────────── Cinta de productos ───────────── */
  function shuffle(list) {
    const a = [...list];
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  function renderStrip(items) {
    const box = $('[data-pm]');
    if (!box) return;
    const pool = shuffle(items);
    const item = (p) => `
      <a class="pm__item tone-${catMeta(p.typeSlug).tone}" href="${ui.productUrl(p.handle)}" aria-label="${esc(p.title)}, ${money(p.price)}">
        <img src="${imgUrl(p.image, 360)}" alt="" loading="lazy" decoding="async">
        <span class="pm__label"><span>${esc(p.title)}</span>${money(p.price)}</span>
      </a>`;
    box.innerHTML =
      ui.marquee(pool.slice(0, 14).map(item).join(''), { speed: 70 }) +
      ui.marquee(pool.slice(14, 28).map(item).join(''), { speed: 80, reverse: true });
  }

  /* ───────────── Cifras, marcas y llamado final ───────────── */
  function renderStats(items) {
    const brands = BW.brandsOf(items).filter((b) => norm(b.name) !== norm(C.storeName));
    const values = { products: items.length, cats: BW.categoriesOf(items).length, brands: brands.length };
    $$('[data-stat]').forEach((el) => { el.dataset.count = String(values[el.dataset.stat] || 0); });
  }

  function renderBrands(items) {
    const box = $('[data-brands]');
    if (!box) return;
    const brands = BW.brandsOf(items).filter((b) => norm(b.name) !== norm(C.storeName));
    const sep = '<span class="brand-sep" aria-hidden="true">✦</span>';
    const html = brands.map((b) =>
      `<a class="brand-chip" href="${ui.shopUrl({ marca: b.name })}">${esc(b.name)}<small>${b.count}</small></a>`).join(sep) + sep;
    box.innerHTML = ui.marquee(html, { speed: 60 });
  }

  function renderCtaFloats(items) {
    const box = $('[data-cta-floats]');
    if (!box) return;
    box.innerHTML = shuffle(items).slice(0, 4)
      .map((p) => `<span class="cta-float"><img src="${imgUrl(p.image, 240)}" alt="" loading="lazy"></span>`).join('');
  }

  /* ───────────── Preguntas frecuentes ───────────── */
  function initFaq() {
    const items = $$('.faq__item');
    const toggle = (d, open) => {
      const body = $('.faq__body', d);
      d.classList.toggle('is-open', open);
      if (!BW.motionOK() || !body.animate) { d.open = open; return; }
      d.dataset.animating = '1';
      if (open) {
        d.open = true;
        const h = body.scrollHeight;
        body.animate([{ height: '0px', opacity: 0 }, { height: `${h}px`, opacity: 1 }], { duration: 420, easing: 'cubic-bezier(.2,.7,.2,1)' })
          .onfinish = () => { delete d.dataset.animating; };
      } else {
        const h = body.scrollHeight;
        body.animate([{ height: `${h}px`, opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 300, easing: 'ease' })
          .onfinish = () => { d.open = false; delete d.dataset.animating; };
      }
    };
    items.forEach((d) => {
      $('summary', d).addEventListener('click', (e) => {
        e.preventDefault();
        if (d.dataset.animating) return;
        const opening = !d.classList.contains('is-open');
        if (opening) items.forEach((o) => { if (o !== d && o.classList.contains('is-open')) toggle(o, false); });
        toggle(d, opening);
      });
    });
  }
})();
